// extracted by mini-css-extract-plugin
export default {"spinner":"loadingSpinner_spinner__G1f2l"};